import React from "react";
import { Location } from "@navigation/Location";
import { TravelRequestPage } from "../TravelRequest/TravelRequestPage";

interface Params {
  requestId: string;
}

export class TravelRequestViewLocation extends Location<Params> {
  render() {
    return <TravelRequestPage requestId={this.params.requestId} />;
  }

  equals(location: Location<Params>): boolean {
    return this.params.requestId === location.params.requestId;
  }

  toURI(): string {
    return `/bookings/travel-request/${this.params.requestId}/view`;
  }
}
